import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const libsApi = {
  authorizeUrl (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/libs/wechat/authorize-url/`,
      querystring.stringify(params)
    )
  },
  userInfo (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/libs/wechat/user-info/`,
      querystring.stringify(params)
    )
  },
  checkAccessToken (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/libs/wechat/check-access-token/`,
      querystring.stringify(params)
    )
  },
  refreshAccessToken (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/libs/wechat/refresh-access-token/`,
      querystring.stringify(params)
    )
  },
  updateUserInfo (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/libs/wechat/update-user-info/`,
      querystring.stringify(params)
    )
  },
  getJSApiConfig (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/libs/wechat/get-jsapi-config/`,
      {params: params})
  }
}

export default libsApi
